import type React from "react";
import { ArrowCircle } from "../../../icons";

export interface ToolCardProps {
  title: string;
  image: string;
  comingSoon?: boolean;
  onClick?: () => void;
}

const ToolCard: React.FC<ToolCardProps> = ({
  title,
  image,
  comingSoon = false,
  onClick,
}) => {
  return (
    <>
      <div
        className="relative bg-white rounded-[11px] border border-[#ebebeb] shadow-[0_0_16.5px_0_rgba(0,0,0,0.1)] overflow-hidden flex-grow-0 p-[0_0_0_7.7px] transition-shadow duration-200 h-[180px] cursor-pointer"
        onClick={onClick}
      >
        <img
          src="/assets/money/rings.webp"
          className="bottom-28 absolute left-[50%] -translate-x-[50%] z-0 pointer-events-none"
        />
        <div className="p-6 flex flex-col h-full">
          <div className="flex justify-between items-start mb-4 w-full">
            <h3
              className={`text-lg font-medium text-gray-900 ${comingSoon ? "w-1/2" : "w-3/4"}`}
            >
              {title}
            </h3>
            {!comingSoon && <ArrowCircle />}
            {comingSoon && (
              <h4 className="text-[11px] bg-[#faf5e5] border-[1px] border-[#ecd996] w-fit py-1 px-3 rounded-[17px] font-normal text-[#090909]">
                Coming Soon
              </h4>
            )}
          </div>

          <div className="absolute bottom-[-26px] left-1/2 transform -translate-x-1/2">
            <img
              src={image}
              alt="investment options"
              className="w-[400px] h-[100px]"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ToolCard;
